import * as React from "react";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { permissionHelper, PublicAmorgUser } from '../../../amorg-common';
import { ProtectedPageWrapper } from "../../../designSystem/layouts/pageWrappers/ProtectedPageWrapper";
import UserPanel from "../../_components/userEditor/UserPanel";
import { SingleColumnLayout } from '../../../designSystem/layouts/SingleColumnLayout';
import { getUser } from "../../../api/userClientApi";
import { PageHeader } from "../../../designSystem/PageHeader";
import { getActiveUser } from "../../../api/authClientApi";

type ParamTypes = Record<string, string | undefined>;

export interface UserPageState {
	activeUser: PublicAmorgUser | null,
	isAdmin: boolean
	user: PublicAmorgUser | undefined,

}

export default function UserPage(): JSX.Element {

	const { userId } = useParams<{userId: string}>();
	const [state, setState] = useState<UserPageState>({
		activeUser: null,
		isAdmin: false,
		user: undefined
	});

	useEffect(() => {

		const getData = async () => {
            const activeUser = await getActiveUser();
            if(!activeUser)
                return;

            const isAdmin = activeUser.permissionGroup.permissions.includes('UserAdmin');
			const user = await getUser(userId || '');

			setState({ activeUser, isAdmin, user });
		};
		getData();

	}, []);

    const canEdit = state.activeUser && state.user
        ? state.activeUser.id === state.user.id || permissionHelper.canAdminEditTargetGroupId(state.activeUser?.permissionGroup.id, state.user?.permissionGroup.id, state.activeUser?.id === state.user?.id)
        : false;

	return (

		<ProtectedPageWrapper requiredPermissions={['ViewUsers']} selectedMenuItemKey='users'>
			<SingleColumnLayout
                noDivider
				contentContainer={
                    <>
                        <PageHeader headerText="Rediger bruger" headerStyle="secondary-gray" />
				
						{state.activeUser && state.user &&
							<>
                                {canEdit ?
								    <>
                                        <UserPanel activeUser={state.activeUser} targetUserId={state.user.id} onSelectedUserUpdated={() => { return; }} />
                                    </>
                                    :
                                    <p>Du har ikke adgang til at redigere denne bruger</p>
								}
							</>
						}
					</>
				}
			/>
		</ProtectedPageWrapper>
	);
}